import { IDataListColumn, Id } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
	mapContactAttributeToListHandler,
	mapContactAttributeToProfileHandler,
} from "../../../shared/contacts/profile/profileContactAttributeMapper";
import { profileSettingsService } from "../profileSettings/profileSettingsService";
import { UserIndexResource } from "../shared/types";
import { ProfileContactViewResource } from "../shared/types/profileSettings";

export const useGetProfileContactView = () => {
	const { data: defaultContactView } = useQuery({
		queryKey: profileSettingsService.getDefaultContactViewKey,
		queryFn: () => profileSettingsService.getDefaultContactView().then((res) => res.data.data),
	});

	return {
		profileContactView: defaultContactView || null,
	};
};

const renderProfileAttribute = (user: UserIndexResource, contactAttributeId: Id) => {
	const attribute = user.attributes.find((a) => a.id === contactAttributeId);
	const attributeHandler = attribute ? mapContactAttributeToProfileHandler(attribute) : null;

	if (!attributeHandler) {
		return "-";
	}

	return attributeHandler.renderValue() || "-";
};

export const useUserListColumns = (
	contactView: ProfileContactViewResource | null,
): IDataListColumn<UserIndexResource>[] => {
	const { t } = useTranslation();

	if (!contactView) return [];

	return contactView.contactAttributes.map((contactAttribute) => {
		const attributeHandler = mapContactAttributeToListHandler(contactAttribute);

		if (!attributeHandler) {
			return {
				heading: t("Unknown attribute"),
				size: "max-content",
				valueKey: contactAttribute.id as any,
				type: "value",
				render: () => "-",
			};
		}

		return {
			heading: attributeHandler.getLabel(t),
			size: attributeHandler.getColumnSize(),
			valueKey: attributeHandler.id as any,
			type: "value",
			render: (user) => renderProfileAttribute(user, contactAttribute.id),
		};
	});
};
